import { ovl, SYSScreen } from "../.."
import type { SYSLongRunningProcess, SYSDialog, SYSTableDefIds } from "../.."
import { T } from "../../textapi"
import { SnackAdd, SnackTrackedAdd, SnackTrackedRemove } from "../snackapi"
import type { SYSFormState } from "../forms/actions"
import type {
  LongRunningProcessState,
  _ProcessReturnType,
  ProcessSnackType,
} from "./longrunningprocesstracker"
import { TableRowFnProcessFeedback_Type } from "../../global/hooks"
import { RowControlAction, SYSTableData, SYSTableDef } from "../table/table"
import { TableGet, _TableGetReturnType } from "../table/tableapi"

export const ProcessRunningChangeSnack = (
  processType: SYSLongRunningProcess,
  snack: ProcessSnackType,
  instance?: string
) => {
  if (!instance) {
    instance = processType
  }
  let processState = ovl.getState().ovl.longRunningProcessTracker[processType]
  let processInstanceState = processState.instance[instance]
  if (snack.type !== "none") {
    processState.snack = snack
    let hasTrackedSnack = snack.fireAndForgetSnackDuration === undefined
    let id = `${processType}_${instance}`

    let text = snack.text
    if (!text) {
      text = T(processType, [instance])
    }
    if (hasTrackedSnack) {
      let snackId = SnackTrackedAdd(text, snack.type, id)
      processInstanceState.id = snackId
      processInstanceState.hasTrackedSnack = hasTrackedSnack
    } else {
      SnackAdd(text, snack.type, snack.fireAndForgetSnackDuration)
    }
  } else {
    SnackTrackedRemove(processInstanceState.id)
  }
}

export const ProcessStart = (
  processType: SYSLongRunningProcess,
  options?: {
    snack?: ProcessSnackType
    lock?: {
      formState?: SYSFormState[] | SYSFormState
      dialog?: SYSDialog
      dialogInstance?: any
      screen?: SYSScreen
    }
    instance?: string
    isRefresh?: boolean
    // provide the locked tableKeys as Object wo we can quickly can check the keys
    tableFn?: {
      lockedTableKeys?: {}
      selectedKeys?: {}
      fnName?: string
      fnId: string
      tableDefId: SYSTableDefIds
      rowKey: string
    }
  }
): _ProcessReturnType => {
  let instance
  let snack
  let lock
  if (options) {
    snack = options.snack
    instance = options.instance
    lock = options.lock
    if (lock && !lock.dialogInstance) {
      lock.dialogInstance = lock.dialog
    }
  }
  return ovl.getActions().ovl.internal._LongRunningProcessStart({
    processType,
    instance,
    snack,
    lock,
    tableFn: options?.tableFn,
  })
}

export type _ProcessGetRowFnsFeedbackOptionsType = {
  rowFnIds?: string[]
  customRowActions?: RowControlAction[]
  rowKeys?: string[]
}

export type _ProcessGetRowFnsFeedbackReturnType = {
  involvedProcessInstances: LongRunningProcessState[]
}

// export const ProcessGetRowFnsFeedback = (
//   tableDefId: SYSTableDefIds,
//   options?: _ProcessGetRowFnsFeedbackOptionsType
// ): _ProcessGetRowFnsFeedbackReturnType => {
//   let result: _ProcessGetRowFnsFeedbackReturnType = {
//     involvedProcessInstances: [],
//   }
//   let customRowActions = options?.customRowActions
//   let processesState = ovl.getState().ovl.longRunningProcessTracker
//   if (!customRowActions) {
//     let def = TableGet(tableDefId).def
//     if (options?.rowFnIds) {
//       customRowActions = options.rowFnIds
//         .filter((k) => def.options.customRowActions[k].process !== "None")
//         .map((k) => def.options.customRowActions[k])
//     } else {
//       customRowActions = Object.keys(def.options.customRowActions)
//         .filter((k) => def.options.customRowActions[k].process !== "None")
//         .map((k) => def.options.customRowActions[k])
//     }
//   }
//   customRowActions = customRowActions.filter((f) => f.process !== "None")
//   // now if we have rowKeys in options we can use those to retrieve the key instance of the process
//   // (thats faster than looping through instances and used eg. from row component)
//   if (options?.rowKeys) {
//     // options.rowKeys.forEach((rowKey) => {
//     //   customRowActions.forEach((customRowAction) => {
//     //     let processInstance =
//     //       processesState[customRowAction.process].instance?.[
//     //         `${tableDefId}_OvlSep_${customRowAction.fnKey}_OvlSep_${rowKey}`
//     //       ]
//     //     // let feedback = processInstance?.feedback?.[rowKey]
//     //     // if (feedback) {
//     //     //   if (!result.rowKeyRowFnsFeedback[rowKey]) {
//     //     //     result.rowKeyRowFnsFeedback[rowKey] = {}
//     //     //   }
//     //     //   result.involvedProcessInstances.push(processInstance)
//     //     //   result.rowKeyRowFnsFeedback[rowKey][customRowAction.fnKey] = feedback
//     //     // }
//     //   })
//     // })
//     // add the ones from multi process
//     customRowActions.forEach((customRowAction) => {
//       let processInstance =
//         processesState[customRowAction.process].instance?.[
//           `${tableDefId}_OvlSep_${customRowAction.fnKey}_OvlSep_Multi`
//         ]
//       // let multiFeedback = processInstance?.feedback
//       // if (multiFeedback) {
//       //   let keys
//       //   if (options?.rowKeys) {
//       //     keys = options.rowKeys
//       //   } else {
//       //     keys = Object.keys(multiFeedback)
//       //   }
//       //   keys.forEach((k) => {
//       //     if (multiFeedback[k]) {
//       //       if (!result.rowKeyRowFnsFeedback[k]) {
//       //         result.rowKeyRowFnsFeedback[k] = {}
//       //       }
//       //       result.rowKeyRowFnsFeedback[k][customRowAction.fnKey] =
//       //         multiFeedback[k]
//       //     }
//       //   })
//       result.involvedProcessInstances.push(processInstance)
//       //      }
//     })
//   } else {
//     // loop all relevant
//     customRowActions.forEach((customRowAction) => {
//       let processInstance: { [key: string]: LongRunningProcessState } =
//         processesState[customRowAction.process].instance
//       Object.keys(processInstance)
//         .filter(
//           (k) =>
//             processInstance[k].tableFn?.tableDefId === tableDefId &&
//             //processInstance[k].feedback &&
//             processInstance[k].tableFn?.fnId === customRowAction.fnKey
//         )
//         .forEach((instanceKey) => {
//           result.involvedProcessInstances.push(processInstance[instanceKey])
//           // Object.keys(processInstance[instanceKey].feedback).forEach((k) => {
//           //   let feedback = processInstance[instanceKey].feedback[k]
//           //   if (!result.rowKeyRowFnsFeedback[k]) {
//           //     result.rowKeyRowFnsFeedback[k] = {}
//           //   }
//           //   result.rowKeyRowFnsFeedback[k][customRowAction.fnKey] = feedback
//           // })
//         })
//     })
//   }
//   return result
// }

export const ProcessEnd = (
  processType: SYSLongRunningProcess,
  instance?: string
) => {
  ovl.getActions().ovl.internal._LongRunningProcessEnd({
    processType,
    instance,
  })
}

export const ProcessIsServerAccessRunning = (): boolean => {
  let procState = ovl.getState().ovl.longRunningProcessTracker
  return Object.keys(procState)
    .filter((f) => procState[f].isRefresh)
    .some((s) => ProcessIsRunning(<SYSLongRunningProcess>s))
}

export const ProcessIsRunning = (
  processType: SYSLongRunningProcess,
  instance?: string
): boolean => {
  let procState = ovl.getState().ovl.longRunningProcessTracker[processType]
  if (procState) {
    if (!instance) {
      // if there is no isntance just check if any is running
      let procState = ovl.getState().ovl.longRunningProcessTracker[processType]
      if (procState?.instance) {
        return Object.keys(procState.instance).some(
          (s) => procState.instance[s].isRunning
        )
      }
      return false
    }
    if (!procState["instance"][instance]) {
      // its important to init here because tracking wont work elsewise
      procState["instance"][instance] = {
        hasTrackedSnack: false,
        id: "",
        isRunning: false,
        refCounter: 0,

        currentFeedback: {},
        tableFn: {},
        processType,
        instanceId: instance,
      }
      procState["instance"][instance]["tableFn"].lockedTableKeys = {}
    }
    let instanceState = procState["instance"][instance]
    let isRunning = !!instanceState.isRunning

    // leave it for the tracking
    !!instanceState?.tableFn?.lockedTableKeys

    return isRunning
  }
  return false
}

// not needed... just call ProcessIsRunning without providing an instance
// export const ProcessIsAnyInstanceRunning = (
//   processType: SYSLongRunningProcess
// ): boolean => {
//   let procState = ovl.getState().ovl.longRunningProcessTracker[processType]
//   if (procState?.instance) {
//     return Object.keys(procState.instance).some(
//       (s) => procState.instance[s].isRunning
//     )
//   }
//   return false
// }
